import { MenuFoldOutlined } from "@ant-design/icons";
import React, { useState } from "react";
import styled from "styled-components";

const BrandBarContainer = styled.div`
display: flex;
justify-content: space-between;
align-items: center;
color:white;
background: var(--primary-color);
justify-content: center;
position: sticky;
top: 0;
padding:0.5rem;
img
{
    width: auto;
}
`;

const BrandDashboard = (props: {
    imgHeight?: string
    style?: React.CSSProperties
    click: boolean
    setClick: React.Dispatch<React.SetStateAction<boolean>>
}) => {
    const [hovered, setHovered] = useState(false);
    const handleMouseEnter = () => setHovered(true);
    const handleMouseLeave = () => setHovered(false);
    return (
        <BrandBarContainer style={props.style} >
            <img style={{ height: props.imgHeight ?? '25px' }} src="/logotipo.png" />
            <MenuFoldOutlined onClick={() => props.setClick(true)} style={{ marginLeft: "15px", backgroundColor: hovered ? "rgba(255,255,255,0.5)" : undefined, padding: "5px", borderRadius: "15%" }} onMouseEnter={ handleMouseEnter } onMouseLeave = { handleMouseLeave }/>
        </BrandBarContainer>
    );
}

export default BrandDashboard;